import React from 'react'
import styles from './SignIn.module.scss';

function SignUpLink({ onClick }: {
  onClick: () => void,
}) {
  return (
    <div className={styles.footerSwitch}>
      Don’t have an account?
      {' '}
      <span onClick={onClick}>Sign Up</span>
    </div>
  )
}

export default SignUpLink
